import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Layout from '@common/layout';
import { ContentRouteUtil, RouteUrl } from '@utils/routeUtil';
import UrlUtil from '@utils/urlUtil';
import SocialLoginUtil from '@utils/SocialLoginUtil';

const KakaoLoginPage = () => {
  const { query, push } = useRouter();

  useEffect(() => {
    //TODO: URL로 접근시 리다이렉트 되도록 소스 추가 필요
    if (!query.code) return;

    const authenticate = async () => {
      const loginRs = await SocialLoginUtil.kakaoLogin(query.code as string);
      const state = query.state ? decodeURIComponent(query.state.toString()) : '';

      if (loginRs.registered === false) {
        //소셜 로그인전에 포함된 쿼리스트링 불러옴
        const prevQuery = query.state ? UrlUtil.getQueryStringObjectFromURL(state) : {};

        push({
          pathname: ContentRouteUtil.getJoinUrl(),
          query: {
            ...prevQuery,
            ...loginRs.joinQuery,
          },
        });
      } else {
        const redirectPath = state || RouteUrl.INDEX;
        push(redirectPath);
      }
    };

    authenticate();
  }, [query.code]);

  return <Layout />;
};

export default KakaoLoginPage;
